<div class="duna-catering-container">
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Forplejning</h1></mat-card-title>
      <mat-card-subtitle>
        Events med forplejning der afventer godkendelse, samt allerede godkendte events.
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>

  <mat-card class="table-card">
    <mat-card-header>
      <mat-card-title>Afventer / kræver gen-godkendelse</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-dynamic-table #pendingTable [dynamicInput]="{ dataSource: { type: 'text', value: 'duna_catering_pending' } }">
      </app-dynamic-table>
    </mat-card-content>
  </mat-card>

  <mat-card class="table-card">
    <mat-card-header>
      <mat-card-title>Godkendt</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-dynamic-table #approvedTable [dynamicInput]="{ dataSource: { type: 'text', value: 'duna_catering_approved' } }">
      </app-dynamic-table>
    </mat-card-content>
  </mat-card>
</div>
